/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgShopeeFood = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    viewBox="0 0 24 24"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <path
      fill="currentColor"
      d="M17 2c-2.705 0-4.75 3.097-4.75 6.807 0 2.443.766 4.525 2.131 5.909.22.223.364.64.37 1.028l.146 4.656v1.334l4.351.02.002-1.36.197-4.61-.003-.209c.032-.393.08-.577.255-.77l.071-.072c1.33-1.265 1.98-3.328 1.98-5.926C21.75 5.097 19.705 2 17 2Zm-6.591.713.431 8.629a3.75 3.75 0 0 1-1.002 2.744l-.153.155-.187.178a2.25 2.25 0 0 0-.675 1.324l-.018.19-.292 5.778-4.072.029-.242-5.775a2.25 2.25 0 0 0-.577-1.413l-.138-.14-.173-.162a3.75 3.75 0 0 1-1.195-2.711l.005-.22.43-8.606 1.498.07-.255 6.705a.25.25 0 0 0 .182.251l.057.01H5.5a.267.267 0 0 0 .232-.136l.013-.041.004-.085.001-6.737h1.5v6.748a.25.25 0 0 0 .193.244l.057.006h1.442a.25.25 0 0 0 .244-.192l.006-.058-.281-6.713 1.498-.072Z"
    />
  </svg>
)
const Memo = memo(SvgShopeeFood)
export default Memo
